<nb-card size="large" style="width: 95vw; height: 95vh" accent="primary">
  <nb-card-header>
    <div class="header-content">
      <div class="close-button-wrapper">
        <button id="my-cars-modal-close-x" nbButton ghost size="small" class="close-button fa-pull-right" (click)="cancelCar()">
          <nb-icon icon="close-outline" pack="eva"></nb-icon>
        </button>
      </div>
      <div class="title">
        <ng-container>
          <h3 style="text-transform: capitalize" class="fa-pull-left">
            <!--            <span class="cart-icon">-->
            <!--              <fa-icon [icon]="faCartPlus" matTooltip="הוסף לרשימת הרכבים שלי" (click)="addToBasket(data)"></fa-icon>-->
            <!--            </span>-->

            {{data.Manufacturer}}
          </h3>
          <div class="fa-pull-left">
            <app-share-car [car]="data" [requireUpdate]="formChanged" (notifyParent)="handleNotify()"></app-share-car>
          </div>
        </ng-container>

      </div>

    </div>
  </nb-card-header>
  <nb-card-body>
    <div *ngIf="isLoading" class="loading-indicator">
      <!-- Display loading indicator or message here -->
      Loading...
    </div>
    <div *ngIf="!isLoading">
      <ng-container>
        <form action="" [formGroup]="carForm">
          <div class="form-row mb-2">
            <div class="col-md-3">
              <label for="Manufacturer">{{ 'CAR_MARKET.MANUFACTURER' | translate }}</label>
              <span class="black data" id="Manufacturer">
                {{carForm.controls['Manufacturer'].value}}
                <!--                  <span class="cart-icon">-->
                <!--                    <fa-icon [icon]="faCartPlus" matTooltip="הוסף לרשימת הרכבים שלי" (click)="addToBasket(data)"></fa-icon>-->
                <!--                  </span>-->
              </span>
            </div>
            <div class="col-md-3">
              <label for="Model">{{ 'CAR_MARKET.MODEL' | translate }}</label>
              <span class="black data" id="Model">{{carForm.controls['Model'].value}}</span>
            </div>
            <div class="col-md-3">
              <label for="SaleCondition">{{ 'CAR_MARKET.VEHICLE_CONDITION' | translate }}</label>
              <span class="black data" id="SaleCondition">{{carForm.controls['SaleCondition'].value}}</span>
            </div>
            <div class="col-md-3">
              <label for="FuelType">{{ 'CAR_MARKET.VEHICLE_TYPE' | translate }}</label>
              <span class="black data" id="FuelType">{{carForm.controls['FuelType'].value}}</span>
            </div>
          </div>
          <div class="form-row mb-2">
            <div class="col-md-6">
              <div class="form-row">
                <div class="col-md-6 form-group">
                  <label  for="CarPrice">{{ 'CAR_MARKET.PRICE_FROM_LAST_UPDATE' | translate }} {{ 'CAR_MARKET.IN_ISRAEL' | translate }}</label>
                  <span class="black data" *ngIf="loaded">{{currencyService.convertFromIls(round(data.C_Price,0)) | currency: currencyService.code : 'symbol' : '1.0-0'}}</span>
                  <label  for="CarPrice">{{ 'CAR_MARKET.ESTIMATED_PRICE' | translate }} {{ 'CAR_MARKET.FOR_TAXI' | translate }} {{ 'CAR_MARKET.AFTER_CUSTOMS' | translate }} {{ 'CAR_MARKET.IN_ISRAEL' | translate }}</label>
                  <span class="black data" *ngIf="loaded">{{currencyService.convertFromIls(round(data.C_PriceComTaxi,0)) | currency: currencyService.code : 'symbol' : '1.0-0'}}</span>
                  <!--              <span class="black data">{{carForm.get('CurrencyType').value}}</span>-->
                  <img *ngIf="loaded" src="/assets/images/Taxi_logo.png" alt="" width="60" height="20" style="border:2px solid black; border-radius: 4px"/>
                </div>
              </div>
              <div class="form-row mb-2">
                <div class="col-md-6 form-group">
                  <label for="">{{ 'CAR_MARKET.BASE_PRICE_ORIGIN' | translate }}</label>
                  <span class="black data" *ngIf="loaded">{{data.CarPrice|currency:data.CurrencyType:'symbol' : '1.0-0'}}</span>
                  <!--              <span class="black data">{{carForm.get('CurrencyType').value}}</span>-->
                </div>
              </div>

              <div class="form-row mb-2">
                <div class="col-md form-group">
                  <label for="CarPrice">{{ 'CAR_MARKET.PRICE_FROM_LAST_UPDATE' | translate }} {{ 'CAR_MARKET.IN_ISRAEL' | translate }}</label>
                  <div *ngIf="!loaded">
                    <mat-spinner [diameter]="32"></mat-spinner>
                    <span class="black data">{{ 'CAR_MARKET.CALCULATING' | translate }}</span>
                  </div>
                  <span class="black data" *ngIf="loaded">{{currencyService.convertFromIls(data.C_Price) | currency: currencyService.code : 'symbol' : '1.0-0'}}</span>

                </div>
              </div>
              <div class="form-row mb-2">
                <div class="col-md form-group">
                  <label for="">{{ 'CARS.CUSTOMER_PRICE_AFTER_SURCHARGE' | translate }}</label>
                  <span class="black data" *ngIf="loaded">{{currencyService.convertFromIls(calculatedValueForCustomer) | currency: currencyService.code : 'symbol' : '1.0-0'}}</span>
                  <!--              <span class="black data">{{carForm.get('CurrencyType').value}}</span>-->
                </div>
              </div>
              <div class="form-row mb-2">
                <div class="col-md-3">
                  <label for="">{{ 'CAR_MARKET.MILEAGE' | translate }}</label>
                  <span class="black data">{{carForm.get('Mileage').value}}</span>
                </div>
                <div class="col-md-3">
                  <label for="">{{ 'CAR_MARKET.WEIGHT' | translate }}</label>
                  <span class="black data">{{getWeightText()}}</span>
                  <!--              <span class="black data">{{carForm.get('TotalWeight').value}}</span>-->
                </div>
              </div>
              <div class="form-row">
                <div class="col-md-6" *ngIf="carForm.get('SaleCondition').value !== 'New'">
                  <label for="">{{ 'CAR_MARKET.FIRST_USE' | translate }}</label>
                  <span class="black data">{{carForm.get('FirstUseDate').value}}</span>
                </div>
                <div class="col-md-6">
                  <label for="">{{ 'CAR_MARKET.MODEL_YEAR' | translate }}</label>
                  <span class="black data">{{carForm.get('ManufactureDate').value}}</span>
                </div>
              </div>
              <div class="form-row mb-2">
                <div class="col-md-6" *ngIf="carForm.get('RateType').value !== 'EXW'">
                  <label for="">InLand Delivery Price</label>
                  <span class="black data">{{carForm.get('OverlandDeliveryPrice').value}}</span>
                </div>
                <div class="col-md-6">
                  <label for="">{{ 'CAR_MARKET.FINISH_LEVEL' | translate }}</label>
                  <span class="black data">{{carForm.get('FinishLevel').value}}</span>
                </div>
              </div>

              <div class="form-row">
                <div class="col-md-6">
                  <label for="">{{ 'CAR_MARKET.COLOR' | translate }}</label>
                  <span class="black data">{{carForm.get('ExteriorColor').value}}</span>
                </div>
                <div class="col-md-6">
                  <label for="">{{ 'CAR_MARKET.UPHOLSTERY_COLOR' | translate }}</label>
                  <span class="black data">{{carForm.get('UpholsteryColor').value}}</span>
                </div>
              </div>
              <div class="form-row">
                <div class="col-md-6 form-group">
                  <label for="">{{ 'CAR_MARKET.DOORS' | translate }}</label>
                  <span class="black data">{{carForm.get('NumberOfDoors').value}}</span>
                </div>
                <div class="col-md-6 form-group">
                  <label for="">{{ 'CAR_MARKET.SEATS' | translate }}</label>
                  <span class="black data">{{carForm.get('NumberOfSeats').value}}</span>
                </div>
              </div>

              <div class="form-row mb-2">
                <div class="col-md-6">
                  <label for="">{{ 'CAR_MARKET.ORIGIN_DISCOUNT_BENEFIT' | translate }}</label>
                  <span class="black data">{{carForm.get('CertificateOfOrigin').value === 'Yes' ? ('COMMON.YES' | translate) : ('COMMON.NO' | translate)}}</span>
                </div>
                <div class="col-md-6">
                  <label for="">{{ 'CAR_MARKET.IN_ISRAEL' | translate }}</label>
                  <span class="black data">{{carForm.get('Location').value === 'Israel' ? ('COMMON.YES' | translate) : ('COMMON.NO' | translate)}}</span>
                </div>
              </div>
              <div class="form-row mb-2">
                <div class="col-md-12 form-group">
                  <div  class="info-grafik-content">
                    <div  class="color-bar" >
                      <div class="form-row">
                        <span style="font-size: 14px; font-weight: bold;">{{ 'CAR_MARKET.AIR_POLLUTION_GRADE' | translate }}</span>
                      </div>
                      <div class="form-row">
                        <div class="col-md-6 form-group">
                          <span  class="min-text">{{ 'CAR_MARKET.MIN_POLLUTION' | translate }}</span>
                        </div>
                        <div class="col-md-6 form-group">
                          <span  class="max-text right">{{ 'CAR_MARKET.MAX_POLLUTION' | translate }}</span>
                        </div>
                      </div>
                      <div  class="row-blocks">
                        <div  class="rank-color"
                              [class.selected]="carForm.get('PollutionRank').value === 1"
                              style="background-color: rgb(35, 64, 49);">
                          1
                          <i *ngIf="carForm.get('PollutionRank').value === 1" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                        <div  class="rank-color"
                              [class.selected]="carForm.get('PollutionRank').value === 2"
                              style="background-color: rgb(15, 87, 50);">
                          2
                          <i *ngIf="carForm.get('PollutionRank').value === 2" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                        <div  class="rank-color"
                              [class.selected]="carForm.get('PollutionRank').value === 3"
                              style="background-color: rgb(28, 111, 59);">
                          3
                          <i *ngIf="carForm.get('PollutionRank').value === 3" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                        <div  class="rank-color"
                              [class.selected]="carForm.get('PollutionRank').value === 4"
                              style="background-color: rgb(88, 162, 110);">
                          4
                          <i *ngIf="carForm.get('PollutionRank').value === 4" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                        <div  class="rank-color"
                              [class.selected]="carForm.get('PollutionRank').value === 5"
                              style="background-color: rgb(23, 154, 53);">
                          5
                          <i *ngIf="carForm.get('PollutionRank').value === 5" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                        <div  class="rank-color"
                              [class.selected]="carForm.get('PollutionRank').value === 6"
                              style="background-color: rgb(73, 175, 36);">
                          6
                          <i *ngIf="carForm.get('PollutionRank').value === 6" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                        <div  class="rank-color"
                              [class.selected]="carForm.get('PollutionRank').value === 7"
                              style="background-color: rgb(165, 207, 45);">
                          7
                          <i *ngIf="carForm.get('PollutionRank').value === 7" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                        <div  class="rank-color"
                              [class.selected]="carForm.get('PollutionRank').value === 8"
                              style="background-color: rgb(253, 239, 32);">
                          8
                          <i *ngIf="carForm.get('PollutionRank').value === 8" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                        <div  class="rank-color"
                              [class.selected]="carForm.get('PollutionRank').value === 9"
                              style="background-color: rgb(254, 198, 9);">
                          9
                          <i *ngIf="carForm.get('PollutionRank').value === 9" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                        <div  class="rank-color"
                              [class.selected]="carForm.get('PollutionRank').value === 10"
                              style="background-color: rgb(246, 149, 0);">
                          10
                          <i *ngIf="carForm.get('PollutionRank').value === 10" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                        <div  class="rank-color"
                              [class.selected]="carForm.get('PollutionRank').value === 11"
                              style="background-color: rgb(241, 144, 76);">
                          11
                          <i *ngIf="carForm.get('PollutionRank').value === 11" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                        <div  class="rank-color"
                              [class.selected]="carForm.get('PollutionRank').value === 12"
                              style="background-color: rgb(236, 91, 44);">
                          12
                          <i *ngIf="carForm.get('PollutionRank').value === 12" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                        <div class="rank-color"
                             [class.selected]="carForm.get('PollutionRank').value === 13"
                             style="background-color: rgb(203, 36, 11);">
                          13
                          <i *ngIf="carForm.get('PollutionRank').value === 13" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                        <div  class="rank-color"
                              [class.selected]="carForm.get('PollutionRank').value === 14"
                              style="background-color: rgb(203, 36, 15);">
                          14
                          <i *ngIf="carForm.get('PollutionRank').value === 14" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                        <div  class="rank-color"
                              [class.selected]="carForm.get('PollutionRank').value === 15"
                              style="background-color: rgb(150, 31, 44);">
                          15
                          <i *ngIf="carForm.get('PollutionRank').value === 15" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row mb-2">
                <div class="col-md-8 form-group">
                  <div  class="info-grafik-content">
                    <div  class="color-bar" >
                      <div class="form-row">
                        <span style="font-size: 14px; font-weight: bold;">{{ 'CAR_MARKET.SAFETY_EQUIPMENT_LEVEL' | translate }}</span>
                      </div>
                      <div class="form-row">
                        <div class="col-md-6 form-group">
                          <span  class="min-text">{{ 'CARS.SAFETY_LEVEL_LOW' | translate }}</span>
                        </div>
                        <div class="col-md-6 form-group">
                          <span  class="max-text left">{{ 'CARS.SAFETY_LEVEL_HIGH' | translate }}</span>
                        </div>
                      </div>
                      <div  class="row-blocks">
                        <div  class="rank-color"
                              [class.selected]="carForm.get('EquipLevel').value === 1"
                              style="background-color: rgb(186, 2, 0);">
                          1
                          <i *ngIf="carForm.get('EquipLevel').value === 1" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                        <div  class="rank-color"
                              [class.selected]="carForm.get('EquipLevel').value === 2"
                              style="background-color: rgb(231, 115, 8);">
                          2
                          <i *ngIf="carForm.get('EquipLevel').value === 2" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                        <div  class="rank-color"
                              [class.selected]="carForm.get('EquipLevel').value === 3"
                              style="background-color: rgb(255, 200, 0);">
                          3
                          <i *ngIf="carForm.get('EquipLevel').value === 3" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                        <div  class="rank-color"
                              [class.selected]="carForm.get('EquipLevel').value === 4"
                              style="background-color: rgb(58, 184, 149);">
                          4
                          <i *ngIf="carForm.get('EquipLevel').value === 4" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                        <div  class="rank-color"
                              [class.selected]="carForm.get('EquipLevel').value === 5"
                              style="background-color: rgb(56, 144, 167);">
                          5
                          <i *ngIf="carForm.get('EquipLevel').value === 5" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                        <div  class="rank-color"
                              [class.selected]="carForm.get('EquipLevel').value === 6"
                              style="background-color: rgb(44, 151, 208);">
                          6
                          <i *ngIf="carForm.get('EquipLevel').value === 6" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                        <div  class="rank-color"
                              [class.selected]="carForm.get('EquipLevel').value === 7"
                              style="background-color: rgb(3, 123, 200);">
                          7
                          <i *ngIf="carForm.get('EquipLevel').value === 7" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                        <div  class="rank-color"
                              [class.selected]="carForm.get('EquipLevel').value === 8"
                              style="background-color: rgb(7, 126, 252);">
                          8
                          <i *ngIf="carForm.get('EquipLevel').value === 8" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                        <div  class="rank-color"
                              [class.selected]="carForm.get('EquipLevel').value === 9"
                              style="background-color: rgb(19, 83, 255);">
                          9
                          <i *ngIf="carForm.get('EquipLevel').value === 9" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div class="col-md-6">
              <div class="form-group-outline" *ngIf="source !== 'individual'">
                <div class="form-row">
                  <div class="col-md">

                    <div class="toggle-container" *ngIf="source === 'personal'">
                      <div class="header">{{ 'CARS.PRICE_QUOTE_HEADER' | translate }}</div>
                      <mat-button-toggle-group #group="matButtonToggleGroup" [value]="selection" (change)="onImportTypeChange(group.value)" aria-label="Import Type">
                        <mat-button-toggle value="commercial">{{ 'CALC_PAGE.COMMERCIAL_IMPORT' | translate }}</mat-button-toggle>
                        <mat-button-toggle value="personal">{{ 'CALC_PAGE.PERSONAL_IMPORT' | translate }}</mat-button-toggle>
                      </mat-button-toggle-group>
                    </div>

                    <div *ngIf="source === 'personal' && selection === 'none'" class="form-row d-flex align-items-center required-message">
                      <span>{{ 'CARS.PLEASE_SELECT_IMPORT_TYPE' | translate }}</span>
                    </div>

                    <div *ngIf="source === 'personal' && selection === 'personal'" class="form-row d-flex align-items-center">
                      <app-editable-list [(listItems)]="taxList" (listItemsChange)="handleListItemsChange($event)"></app-editable-list>
                    </div>


                    <div *ngIf="source === 'commercial' || (source === 'personal' && selection === 'commercial')" class="form-row d-flex align-items-center">
                      <div class="col-md-4 d-flex align-items-center">
                        <mat-radio-group formControlName="MyIsPCT" (change)="onToggleChange($event)">
                          <mat-radio-button [value]="false" class="mr-2">{{ 'CARS.SURCHARGE_IN_ILS' | translate }}</mat-radio-button>
                          <mat-radio-button [value]="true" class="mr-2">{{ 'CARS.SURCHARGE_IN_PERCENT' | translate }}</mat-radio-button>
                        </mat-radio-group>
                      </div>

                      <div class="col-md-4 form-group d-flex align-items-center price-row">
                        <!--                        <label for="CarPrice" class="mr-2 switch-label">מחיר </label>-->
                        &nbsp;<input type="number" nbInput status="primary"
                                     [placeholder]="'CAR_MARKET.PRICE' | translate"
                                     formControlName="MyCarPrice"
                                     required>&nbsp;
                        <span *ngIf="carForm.get('MyIsPCT').value" class="ml-2">%</span>
                        <span *ngIf="!carForm.get('MyIsPCT').value" class="ml-2">₪ </span>
                      </div>
                    </div>

                    <div class="form-row form-group align-items-center" *ngIf="source === 'commercial' || selection !== 'none'">
                      <label for="" class="col-sm-2 col-form-label">{{ 'CARS.IMPORTER_LABEL' | translate }}</label>
                      <div class="col-sm-10">
                        <input type="text" nbInput status="primary"
                               [placeholder]="'CARS.IMPORTER_LABEL' | translate"
                               formControlName="MyImporter"
                               required class="form-control full-width">
                      </div>
                    </div>

                    <div class="form-row form-group" *ngIf="source === 'commercial' || selection !== 'none'">
                      <label for="">{{ 'CARS.NOTES_LABEL' | translate }}</label>
                      <textarea nbInput fullWidth status="primary" [placeholder]="'CARS.NOTES_LABEL' | translate"
                                formControlName="MyNotes"
                                rows="4"></textarea>
                    </div>
                    <div class="form-row form-group" *ngIf="source === 'commercial' || selection !== 'none'">
                      <label for="">{{ 'CARS.DEAL_TERMS_LABEL' | translate }}</label>
                      <textarea nbInput fullWidth status="primary" [placeholder]="'CARS.DISCLAIMER_PLACEHOLDER' | translate"
                                formControlName="MyDisclaimer"
                                rows="4"></textarea>
                    </div>
                    <div class="form-row form-group align-items-center" *ngIf="source === 'commercial' || selection !== 'none'">
                      <label for="" class="col-sm-2 col-form-label">{{ 'CARS.CUSTOMER_NAME_LABEL' | translate }}</label>
                      <div class="col-sm-10">
                        <input type="text" nbInput status="primary"
                               [placeholder]="'CARS.CUSTOMER_NAME_LABEL' | translate"
                               formControlName="MyCustomer"
                               required class="form-control full-width">
                      </div>
                    </div>


                  </div>
                </div>


              </div>
            </div>

          </div>
          <div [ngClass]="data.Files.length > 0 ? 'form-group-outline': ''">
            <div class="form-row">
              <div class="col">
                <div class="d-flex flex-row overflow-auto">
                  <div class="p-2" *ngFor="let file of data.Files; let i = index">
                    <img [src]="file.url" class="img-fluid" class="photo" (click)="openDialog(i)">
                  </div>
                </div>
                <!-- <ngx-file-upload (filesChanged)="onFilesChanged($event)" [files]="photos"></ngx-file-upload> -->
              </div>
            </div>
          </div>

        </form>
      </ng-container>
    </div>
  </nb-card-body>
  <nb-card-footer class="sticky-footer">
    <div class="row">

      <div class="col text-right">
        <button id="my-cars-modal-close" nbButton matRipple (click)="cancelCar()" class="mr-2">{{ 'CAR_MARKET.BACK' | translate }}</button>

        <button id="my-cars-modal-update"
          nbButton status="primary" class="mr-4 ml-4"
                (click)="update()">{{ 'CARS.UPDATE_BUTTON' | translate }}
        </button>

      </div>
    </div>

  </nb-card-footer>
</nb-card>

<p-toast position="top-left"></p-toast>
